module.exports = __webpack_public_path__ + "img/Advanced Search - Pink.2741d046.png";